// Debug utility with toggleable logging categories
// Usage: import { debug } from './debug'
//        debug.app('message', data)
//        debug.materials('message', data)

// Master switch - set to false to disable ALL debug logs
const DEBUG_ENABLED = true

// Category switches - toggle individual categories
const DEBUG_CATEGORIES = {
  app: false,        // App.js main flow
  materials: false,  // materialManager, material selection
  admin: false,      // Admin panel operations
  api: false,        // API calls
  viewer: false,     // Emersya viewer interactions
  config: false,     // config.js material queue
  planner: false,    // Planner component
  forms: false,      // Form submissions (FamilyForm, ProductForm)
}

// Enable all categories at once (for debugging sessions)
// Set to true to enable all categories regardless of individual settings
const DEBUG_ALL = false

const createLogger = (category) => {
  return (...args) => {
    if (!DEBUG_ENABLED) return
    if (!DEBUG_ALL && !DEBUG_CATEGORIES[category]) return

    const prefix = `[${category.toUpperCase()}]`
    console.log(prefix, ...args)
  }
}

const createWarner = (category) => {
  return (...args) => {
    if (!DEBUG_ENABLED) return
    if (!DEBUG_ALL && !DEBUG_CATEGORIES[category]) return

    const prefix = `[${category.toUpperCase()}]`
    console.warn(prefix, ...args)
  }
}

export const debug = {
  app: createLogger('app'),
  materials: createLogger('materials'),
  admin: createLogger('admin'),
  api: createLogger('api'),
  viewer: createLogger('viewer'),
  config: createLogger('config'),
  planner: createLogger('planner'),
  forms: createLogger('forms'),

  // Warnings (same categories)
  warn: {
    app: createWarner('app'),
    materials: createWarner('materials'),
    admin: createWarner('admin'),
    api: createWarner('api'),
    viewer: createWarner('viewer'),
    config: createWarner('config'),
    planner: createWarner('planner'),
    forms: createWarner('forms'),
  },

  // Always log (for critical info even in production)
  always: (...args) => console.log('[INFO]', ...args),

  // Check if a category is enabled
  isEnabled: (category) => DEBUG_ENABLED && (DEBUG_ALL || DEBUG_CATEGORIES[category]),

  // Enable/disable categories at runtime (for dev console)
  enable: (category) => { DEBUG_CATEGORIES[category] = true },
  disable: (category) => { DEBUG_CATEGORIES[category] = false },
  enableAll: () => { Object.keys(DEBUG_CATEGORIES).forEach(k => DEBUG_CATEGORIES[k] = true) },
  disableAll: () => { Object.keys(DEBUG_CATEGORIES).forEach(k => DEBUG_CATEGORIES[k] = false) },

  // Show current debug status
  status: () => {
    console.log('Debug Status:', { DEBUG_ENABLED, DEBUG_ALL, ...DEBUG_CATEGORIES })
  }
}

// Expose to window for runtime toggling from browser console
if (typeof window !== 'undefined') {
  window.debug = debug
}

export default debug
